import { t } from "i18next"
import { capitalizeFirstLetter, convertToHMSString } from "utils"

const userKpiTargetAchievedTransformer = data => {
  let { tabs, ...tabData } = data?.targetVsAchieved
  let dataKey = Object.keys(tabData || {})?.[0]
  delete tabs["sale"] // to remove the sales temporary, TODO: NEED TO BE DONE BY BE
  let radialArray = []

  tabData[dataKey]?.forEach(item => {
    if (item?.target) {
      let transformedObject = {
        ...item,
        CompletionPercentage: {
          target: item?.target,
          achieved: item?.achieved,
          percentage: item?.completionPercentage ?? 0,
          targetType: tabs?.[dataKey]?.[item?.key]?.short === "TTT" ? "time" : "number",
        },
        CompletionMonthlyPercentage: {
          target: item?.monthlyTarget,
          achieved: item?.monthlyAchieved,
          percentage: item?.completionMonthlyPercentage ?? 0,
          targetType: tabs?.[dataKey]?.[item?.key]?.short === "TTT" ? "time" : "number",
        },
        requiredAchievement: `${(item?.requiredAchievementPerDay ?? 0).toFixed(2)} ${
          tabs?.[dataKey]?.[item?.key]?.short
        } / Day`,
        probability: item?.probability,
        CompletionPercentageTitle: `${tabs?.[dataKey]?.[item?.key]?.short} `,
        CompletionMonthlyPercentageTitle: `${tabs?.[dataKey]?.[item?.key]?.short} `,
        CompletionPercentageValue: Math.min(item?.completionPercentage, 100),
        CompletionMonthlyPercentageValue: Math.min(item?.completionMonthlyPercentage, 100),
        targetColor: tabs?.[dataKey]?.[item?.key]?.targetColor,
        achievedColor: tabs?.[dataKey]?.[item?.key]?.achievedColor,
        title: tabs?.[dataKey]?.[item?.key]?.short,
        completeTargetObj: tabs?.[dataKey]?.[item?.key],
      }

      radialArray.push(transformedObject)
    }
  })

  let tabList = []

  let filterOptions = () => [
    { label: t("Date Range"), value: "CompletionPercentage" },
    { label: t("Month"), value: "CompletionMonthlyPercentage" },
  ]
  tabList = Object.keys(tabs || {}).map(item => ({
    componentType: "radialBar",
    type: "Targets",
    loadType: "target_vs_achieved",
    targetCategory: item,
    dataObject: "target",
    tab: t(capitalizeFirstLetter(item)),
    key: item,
    filterData: filterOptions(),
  }))
  // radial charts have this issue of comparatively setting the max values relative to other values that exist in the data
  // so we have to set a maximum value of range within the radialArray to set a maximum value  TODO need to upgrade version of Antd Chart
  if (radialArray?.length) {
    radialArray.push({ CompletionMonthlyPercentageValue: 100, CompletionPercentageValue: 100 })
  }

  return { ...data, radialData: radialArray, tabList }
}

export default userKpiTargetAchievedTransformer
